import React from 'react';

const PETALS = Array.from({ length: 24 });

/**
 * Watermark — decorative background art.
 * variant="mandala" (inline SVG, saffron at low opacity) placed at a corner,
 * variant="temple" (supplied line-art) centred at the bottom.
 */
export default function Watermark({ variant = 'mandala', position = 'top-right', className = '', style }) {
  if (variant === 'temple') {
    return (
      <img
        src="/images/design/temple-line-art.webp"
        alt=""
        aria-hidden="true"
        className={`watermark watermark--temple${className ? ` ${className}` : ''}`}
        style={style}
      />
    );
  }
  return (
    <svg
      viewBox="0 0 400 400"
      aria-hidden="true"
      focusable="false"
      className={`watermark watermark--mandala watermark--${position}${className ? ` ${className}` : ''}`}
      style={style}
    >
      <g fill="none" stroke="currentColor" strokeWidth="0.9">
        <circle cx="200" cy="200" r="196" />
        <circle cx="200" cy="200" r="160" />
        <circle cx="200" cy="200" r="118" />
        <circle cx="200" cy="200" r="60" />
        <circle cx="200" cy="200" r="18" />
        {PETALS.map((_, i) => (
          <g key={i} transform={`rotate(${i * 15} 200 200)`}>
            <path d="M200 8 C214 48 214 88 200 122 C186 88 186 48 200 8Z" />
            <path d="M200 128 C210 150 210 172 200 186 C190 172 190 150 200 128Z" />
          </g>
        ))}
      </g>
    </svg>
  );
}
